import Grid from "@material-ui/core/Grid"
import React from "react"
import TextField from "@material-ui/core/TextField"
import FormControl from "@material-ui/core/FormControl"
import InputLabel from "@material-ui/core/InputLabel"
import BoardConfirmModal from "../ConfirmModal/BoardConfirmModal"
import FieldSelect from "../../Table/FieldSelect"
import { useBeautyModalStyle } from "./style"
import { useCreate } from "./hooks"

const Create = () => {
    const classes = useBeautyModalStyle()
    const {
        callback, cancelCallback,
        modalTimeStr, disabled, dialogData,
        text, handleChange, handleChangeArticleType
    } = useCreate("single")
    return (
        <BoardConfirmModal
            title="创建预约"
            confirmCallback={callback}
            cancelCallback={cancelCallback}
            modalShow={dialogData.show}
            disabled={disabled}
        >
            <Grid container direction="column" justify="center">
                <div>{modalTimeStr}</div>
                <TextField
                    label="预约说明"
                    value={text}
                    onChange={handleChange}
                />
            </Grid>

            <Grid item>
                <FormControl className={classes.input}>
                    <InputLabel >文章类型</InputLabel>
                    <FieldSelect
                        staticValueList={[]}
                        tableName="beauty_article_type"
                        onChange={handleChangeArticleType}
                        whereQuery={"where: {hidden: {_eq: false}}"}
                    />
                </FormControl>
            </Grid>
        </BoardConfirmModal>
    )
}

export default Create
